import { TemplateRef } from "@angular/core";

export interface PasswordConfig {
  title?: string;
  subtitle?: string;
  content?: string | TemplateRef<any>;
  class?: string;
  params?: object;
  dismiss?:
    | boolean
    | {
        backdrop?: boolean;
        escape?: boolean;
      };
  showCancelAction?: boolean;
}
